export const FeatureFlags = {
  // Roles and Permissions
  CreatePOPermissions: 'permissions-can-create-purchase-orders',
  ViewPOPermissions: 'permissions-can-view-purchase-orders',
  CreateSOPermissions: 'permissions-can-create-sales-orders',
  ViewSOPermissions: 'permissions-can-view-sales-orders',
  ViewInventoryPermissions: 'permissions-can-view-inventory',
  ViewSettingsPermissions: 'permissions-can-view-system-settings',

  WorkOrders: 'workOrders',
  BuySellOrders: 'buy-sell-orders',
  ExpensesWithBusinessEntities: 'expenses-charged-to-business-entities',
  ProductionRuns: 'production-runs',
  VariableProductWeight: 'variable-product-weight',
  CheckPrinting: 'check-printing',
  Accounting: 'accounting',
  OrderBoard: 'order-board',
  CustomFields: 'customFields',
  BIDashboards: 'bi-dashboards',
  POSellThroughSO: 'poSellThroughSo',
  AutomationSettings: 'automation-settings',
  GrowerAccountingSettings: 'grower-accounting-settings',
} as const;

// Client-side feature flags (LaunchDarkly uses different formats for client vs server)
export const FeatureFlagsClient = {
  AutomationSettings: 'automationSettings',
  GrowerAccountingSettings: 'growerAccountingSettings',
} as const;

export const QBO_BASE_URL =
  process.env.QBO_ENVIRONMENT === 'sandbox' ? 'https://sandbox.qbo.intuit.com/app' : 'https://qbo.intuit.com/app';

export const DEBOUNCE_DELAY_LOW = 100;
export const DEBOUNCE_DELAY_MEDIUM = 500;
export const DEBOUNCE_DELAY_HIGH = 1000;

/** Height in px of the fixed global app bar (`modules/pageFrame/SiteHeader`). */
export const GLOBAL_APP_BAR_HEIGHT = 52;
